<template>
    <div class="noassets" v-if="showno">
        <md-result-page class="customized" img-url="/static/icon/kyc.png" text="No kyc partners have been linked yet"
            subtext="">
        </md-result-page>
        <md-button class="mt-3" type="primary" @click="go_link_kycpartner">Link Kyc Partner</md-button>
    </div>
    <div class="kyc-list" v-else>
        <md-scroll-view ref="kyclistscrollView" :scrolling-x="false" @refreshing="$_onRefresh">
            <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                refresh-text="pull to refresh" refresh-active-text="release refreshable"
                refreshing-text="refresh"></md-scroll-view-refresh>
            <kycpartneritem :ct="ct" v-for="ct in computedItems" v-bind:key="ct.id" @refreshkyclist="$_onRefresh">
            </kycpartneritem>
        </md-scroll-view>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import { getcollectiontoollist } from '@/request/api'
import kycpartneritem from '@/views/my/kycpartneritem'

export default {
    name: 'kycpartnerlist',
    components: {
        iconimg,
        kycpartneritem
    },
    data() {
        return {
            showno: true,
            ct_list: [],
        }
    },
    created() {
        this.$toast.loading("Loading...")
        this.get_ct_list(false);
    },
    computed: {
        computedItems() {
            return [...this.ct_list];
        }
    },
    mounted() {
        window.ScrollViewTrigger1 = () => {
            this.$refs.kyclistscrollView.triggerRefresh()
        }
    },
    methods: {
        $_onRefresh() {
            this.get_ct_list(true);
        },
        get_ct_list(refresh) {
            getcollectiontoollist().then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    this.ct_list = res.data;
                    if (this.ct_list.length === 0 || Object.keys(this.ct_list).length === 0) {
                        this.showno = true;
                    }
                    else {
                        this.showno = false;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if (refresh) {
                    this.$refs.kyclistscrollView.finishRefresh();
                }
            })
        },
        go_link_kycpartner() {
            this.$router.push('/linkkycpartner')
        }
    }
}

</script>
<style scoped>
.kyc-list {
    height: 13rem;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/kycpartnerlist.vue